import { logo } from './logo.js';

export const timeline = {
    settings: {
        timelines: document.querySelectorAll('.is-style-is-timeline'),
    },

    init() {
        this.setDOM();
        this.setEvents();
    },

    setDOM() {
        if (!this.settings.timelines) return;

        this.settings.timelines.forEach(timeline => {
            const scroller = document.createElement('div');
            const drag = document.createElement('div');

            scroller.classList.add('is-style-is-timeline__scroller', 'js-timeline-scroller');
            drag.classList.add('is-style-is-timeline__drag', 'js-timeline-drag');
            drag.innerHTML = logo.html;

            timeline.appendChild(scroller);
            scroller.appendChild(drag);
        });
    },

    setEvents() {
        if (!this.settings.timelines) return;

        const stickyOffset = 100;

        window.addEventListener('scroll', () => {
            this.settings.timelines.forEach(timeline => {
                const scroller = timeline.querySelector('.js-timeline-scroller');
                const drag = timeline.querySelector('.js-timeline-drag');

                if (!scroller || !drag) return;

                const timelineRect = timeline.getBoundingClientRect();
                const availableScrollSpace = timeline.offsetHeight - drag.offsetHeight;
                let progress = 0;

                if (timelineRect.top <= stickyOffset) {
                    progress = Math.min(stickyOffset - timelineRect.top, availableScrollSpace);
                    progress = Math.max(0, progress);
                }

                if (isFinite(progress)) {
                    timeline.style.setProperty('--height', `${progress}px`);
                }
            });
        }, { passive: true });
    }
};
